import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

export const TaskDetailAssignTemplates: React.FC = () => {
  return <Typography variant='body2'>Lorem Ipsum</Typography>
}

export const TaskActionAssignTemplates: React.FC = () => {
  return (
    <Button variant='contained' color='primary' size='small'>
      Assign Lorem Ipsum
    </Button>
  )
}
